import styled from "styled-components";

export const ModalContent = styled.div`
  // padding: 2em;
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: flex-end;
  margin-top: 3em;
`;